import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DataStoreFacade, EditorTemplateFacade, UIFacade } from '../../../../facades';
import { map } from 'rxjs/operators';
import { combineLatest } from 'rxjs';
import { TemplateDataStoreFacade } from 'src/app/template/facades';

@Component({
  selector: 'app-editor-template',
  templateUrl: './editor-template.component.html',
  styleUrls: ['./editor-template.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditorTemplateComponent {
  public form: FormGroup;
  public isRequesting = false;
  public options$ = combineLatest([this.dataStoreFacade.partners$, this.dataStoreFacade.folders$, this.editorFacade.isReadOnly$]).pipe(
    map(([partners, folders, isReadOnly]) => {
      return {
        partners,
        folders,
        readOnly: isReadOnly,
      };
    })
  );

  constructor(
    public editorFacade: EditorTemplateFacade,
    private fb: FormBuilder,
    private dataStoreFacade: TemplateDataStoreFacade,
    public uiFacade: UIFacade
  ) {
    this.form = this.fb.group({});
  }
  onSubmit() {
    this.isRequesting = true;
    if (!this.form.invalid) {
      this.uiFacade.showLoading();
      this.editorFacade.save().subscribe(
        (result) => {
          if (result.success) {
            // SAVE SUCESS
            this.form.markAsUntouched();
            this.form.markAsPristine();
            this.isRequesting = false;
            this.uiFacade.hideLoading();
          }
        },
        (err) => {
          this.uiFacade.hideLoading();
        }
      );
    }
  }
  onClose() {
    this.editorFacade.close();
  }
}
